//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/halo/keyring.proto (package dxos.halo.keyring, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/halo/keyring.proto.
 */
export const file_dxos_halo_keyring: GenFile = /*@__PURE__*/
  fileDesc("ChdkeG9zL2hhbG8va2V5cmluZy5wcm90bxIRZHhvcy5oYWxvLmtleXJpbmciSQoJS2V5UmVjb3JkEhIKCnB1YmxpY19rZXkYASABKAwSGAoLcHJpdmF0ZV9rZXkYAiABKAxIAIgBAUIOCgxfcHJpdmF0ZV9rZXliBnByb3RvMw");

/**
 * TODO(burdon): Conflicts with keyring.proto
 *
 * @generated from message dxos.halo.keyring.KeyRecord
 */
export type KeyRecord = Message<"dxos.halo.keyring.KeyRecord"> & {
  /**
   * @generated from field: bytes public_key = 1;
   */
  publicKey: Uint8Array;

  /**
   * @generated from field: optional bytes private_key = 2;
   */
  privateKey?: Uint8Array;
};

/**
 * Describes the message dxos.halo.keyring.KeyRecord.
 * Use `create(KeyRecordSchema)` to create a new message.
 */
export const KeyRecordSchema: GenMessage<KeyRecord> = /*@__PURE__*/
  messageDesc(file_dxos_halo_keyring, 0);

